// extracted by mini-css-extract-plugin
export var buttons = "_a5-0";
export var buttonsActive = "_a5-h";
export var cancelConfirm = "_a5-1";
export var closeButton = "_a5-2";
export var column = "_a5-3";
export var container = "_a5-4";
export var detailHeader = "_a5-6";
export var detailTitle = "_a5-7";
export var detailsContent = "_a5-5";
export var header = "_a5-8";
export var headerWithClose = "_a5-9";
export var icon = "_a5-a";
export var infoIcon = "_a5-c";
export var informationContainer = "_a5-b";
export var sideDrawer = "_a5-d";
export var sideDrawerOpen = "_a5-e";
export var stickyFooter = "_a5-f";
export var typeOption = "_a5-g";